<template>
  <div class="header_bar">
    <div class="wrap">
      <div class="container">
        <div class="test">
          <noscript>
            <strong
              >『您的瀏覽器不支援JavaScript功能，若網頁功能無法正常使用時，請開啟瀏覽器JavaScript狀態』
            </strong>
          </noscript>
          <a
            href="#main"
            class="sr-only sr-only-focusable"
            alt=""
            tabindex="1"
            >跳到主要內容區塊</a
          >
        </div>
        <router-link to="/" title="goTOHome">
          <div class="logo">
            <div class="pic">
              <img src="../../img/logo.png" alt="勞動部勞動力發展署logo" />
            </div>
            <div class="txt">
              <h1 class="title">勞動部勞動力發展署</h1>
              <img
                class="english"
                src="../../img/footer_word.svg"
                alt="勞動部勞動力發展署logo"
              />
            </div>
          </div>
        </router-link>
        <div class="message">
          <a
            id="nav"
            class="block_area"
            href="#nav"
            accesskey="U"
            title="網站標題及導覽列"
          >
            :::
          </a>
          <router-link to="/w.map" title="網站導覽">
            <p :style="{ fontSize: fontSize.p + 'em' }">網站導覽</p>
          </router-link>
          <router-link to="/faq" title="常見問答">
            <p :style="{ fontSize: fontSize.p + 'em' }">常見問答</p>
          </router-link>
          <router-link to="/ServiceEmail" title="聯絡我們">
            <p :style="{ fontSize: fontSize.p + 'em' }">聯絡我們</p>
          </router-link>
          <router-link to="/" title="回首頁">
            <p :style="{ fontSize: fontSize.p + 'em' }">回首頁</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
export default {
  name: "Headerbar",
  props: [],
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header_bar {
  width: 100%;
  margin: 0 auto;
  @include md {
    display: none;
  }
}
.wrap {
  @include main_bgcolor();
  border-bottom: 7px solid $main_sec_color;
  .container {
    padding: 10px 70px;
    @include lg {
      padding: 10px 70px;
    }
    @include sec_width();
    @include flex_between();
    .logo {
      @include flex();
      .txt {
        text-align: left;
        padding-left: 15px;
        .title {
          transform: translateY(3px);
          color: #fff;
          @include lg {
            font-size: $h1;
          }
        }
        .english {
          transform: translateY(-3px);
          width: 98%;
        }
      }
    }
    .message {
      @include flex();
      a {
        &.block_area {
          font-size: 1.563em;
        }
        display: inline-block;
        margin-left: 25px;
        color: #fff;
      }
    }
  }
}
.test {
  // position: fixed;
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
}
.sr-only-focusable {
  padding: 8px;
  color: $main_color;
  background-color: #fff;
  font-size: 1.125em;
}
</style>
